/**
 @author xiaoye
 @date 2020/4/10 3:44 下午
 */
import Vue from 'vue';


Vue.component('FBtn', () => import('@/components/FBtn'));
Vue.component('FUrlBtn', () => import('@/components/FUrlBtn'));
Vue.component('FDialog', () => import('@/components/FDialog'));
Vue.component('FPage', () => import( '@/components/FPage'));
Vue.component('FCharsDrog', () => import('@/components/FCharsDrog'));
Vue.component('FTeamSharePreview', () => import('@/components/FTeamSharePreview'));
Vue.component('FNews', () => import('@/components/FNews'));
Vue.component('FSpanTil', () => import( '@/components/FSpanTil'));
Vue.component('FSvg', () => import( '@/components/FSvg'));
Vue.component('FUpload', () => import('@/components/FUpload'));
Vue.component('FFoldBox', () => import('@/components/FFoldBox/FFoldBox'));
Vue.component('FFnewBox', () => import('@/components/FFoldBox/FFnewBox'));
Vue.component('draggable', () => import('vuedraggable'));
